var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAvatarWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Avatar",
    clipPath: "url(#clip0_1897_32889)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/social/person_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/social/person_24px_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0477 12.9524C19.0477 14.6362 17.6839 16 16.0001 16C14.3163 16 12.9524 14.6362 12.9524 12.9524C12.9524 11.2686 14.3163 9.90479 16.0001 9.90479C17.6839 9.90479 19.0477 11.2686 19.0477 12.9524ZM9.90479 20.5715C9.90479 18.5448 13.9657 17.5239 16 17.5239C18.0343 17.5239 22.0953 18.5448 22.0953 20.5715V21.3334C22.0953 21.7524 21.7524 22.0953 21.3334 22.0953H10.6667C10.2476 22.0953 9.90479 21.7524 9.90479 21.3334V20.5715Z",
    fill: "#98A2B3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1897_32889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatarWhite);
export default __webpack_public_path__ + "static/media/defaultAvatar-white.966e76c77050192cd9bca34978e144ab.svg";
export { ForwardRef as ReactComponent };